import { useState } from 'react';
export const useInput = (
    initialValue: any,
    fieldName: string,
    validationRules: Array<(value: string, fieldName: string) => string>
): {
    value: string;
    validation: {
        touched: boolean;
        errors: string[];
        validate: () => string[];
    };
    reset: () => void;
    bind: {
        value: string;
        onChange: (event: any) => void;
        onBlur: () => void;
    };
} => {
    const [value, setValue] = useState<any>(initialValue);
    const [touched, setTouched] = useState<boolean>(false);
    const [errors, setErrors] = useState<string[]>([]);
    const handleOnChange = (event: any) => {
        if (touched) {
            const errorMessages = validationRules.map((rule) => rule(event.target.value, fieldName)).filter(Boolean);
            setErrors(errorMessages);
        }
        setValue(event.target.value);
    };
    const handleValidation = () => {
        const errorMessages = validationRules.map((rule) => rule(value, fieldName)).filter(Boolean) || [];
        setTouched(true);
        setErrors(errorMessages);
        return errorMessages;
    };
    return {
        value,
        validation: {
            touched,
            errors,
            validate: () => handleValidation(),
        },
        reset: () => {
            setValue('');
            setTouched(false);
            setErrors([]);
        },
        bind: {
            value,
            onChange: (event) => handleOnChange(event),
            onBlur: () => handleValidation(),
        },
    };
};
